


























































































































































































































































































































































import {
  FEATURE_AGENTS_MODULE,
  FEATURE_AGENTS_HISTORIC_DATA_FOR_AGENTS_MATCH,
  FEATURE_AGENTS_PRINCIPALS_MANAGEMENT,
} from "@/constants";
import { AdcontrolProfile, User } from "@/models";
import ClientUserInfo from "@/models/Agents/UserInfo";
import { COMPANY_TYPE } from "@/models/CompanyType";
import { ProfileCapabilitiesService } from "@/services/Profile/CapabilitiesService";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import NotificationBadge, {
  NotificationBadgeGroups,
} from "@/components/Agents/NotificationBadge.vue";

@Component({
  components: {
    NotificationBadge,
  },
})
export default class TheSidebar extends Vue {
  @Getter("user") readonly user!: User;
  @Getter("profile") readonly adcontrolProfile!: AdcontrolProfile;
  @Getter("agentUserInfos") readonly agentUserInfo?: ClientUserInfo;

  @Getter("notificationsGroups/company")
  readonly companyNotificationsCount!: number;
  @Getter("notificationsGroups/products")
  readonly productsNotificationsCount!: number;
  @Getter("notificationsGroups/multipleProducts")
  readonly multipleProductsNotificationsCount!: number;

  duplicatedProductsNotificationGroup: NotificationBadgeGroups[] = [
    NotificationBadgeGroups.MultipleProducts,
    NotificationBadgeGroups.Products,
  ];
  conflictsRegistryNotificationGroup: NotificationBadgeGroups[] = [
    NotificationBadgeGroups.MatchProblem,
  ];
  principalCompanyNotificationGroup: NotificationBadgeGroups[] = [
    NotificationBadgeGroups.Company,
  ];

  get companyAssociationDuplicatesNotificationGroup(): NotificationBadgeGroups[] {
    return this.hasFeature("agents_match_by_product")
      ? [NotificationBadgeGroups.Company]
      : [NotificationBadgeGroups.CompanyAssociationDuplicates];
  }

  get isAdmin(): boolean {
    if (!this.user) {
      return false;
    }

    return this.user.isAdmin;
  }

  get duplicatedClientsNotificationsCount(): number {
    return this.companyNotificationsCount;
  }

  get duplicatedProductsNotificationsCount(): number {
    return (
      this.productsNotificationsCount + this.multipleProductsNotificationsCount
    );
  }

  get agentBasicItemsSolved(): boolean {
    if (!this.hasFeature("agents_match_by_product")) return true;

    return (
      this.duplicatedClientsNotificationsCount +
        this.duplicatedProductsNotificationsCount <=
      0
    );
  }

  get profileIsTv(): boolean {
    return this.adcontrolProfile?.accountType === "tv";
  }

  get isAgency(): boolean {
    return this.user.profile?.isAgency || false;
  }

  get isAdSalesAgency(): boolean {
    if (!this.user) {
      return false;
    }
    return (
      this.user.profile?.company.companyType == COMPANY_TYPE.AD_SALES_AGENCY ||
      this.user.profile?.company.companyType ==
        COMPANY_TYPE.TV_AD_SALES_AGENCY ||
      this.user.adcontrolProfiles?.[0]?.accountCompany.companyType ==
        COMPANY_TYPE.AD_SALES_AGENCY ||
      this.user.adcontrolProfiles?.[0]?.accountCompany.companyType ==
        COMPANY_TYPE.TV_AD_SALES_AGENCY
    );
  }

  get isEbiquity(): boolean {
    return (
      this.user.email == "anthony.cardamone@ebiquity.com" ||
      this.user.email == "team+adcontrol@monade.io"
    );
  }

  get hasAgentsModule(): boolean {
    return ProfileCapabilitiesService.agentsModuleEnabled(
      this.user.profile,
      this.agentUserInfo
    );
  }

  get relativeContainer() {
    return "position-relative";
  }

  getActiveClass(className: string) {
    return this.$route?.name === className ? "nav-item-active" : "";
  }

  hasFeature(feature: string) {
    if (!this.user) {
      return false;
    }

    return this.user.hasFeature(feature);
  }

  showSpecialInitiativesSection(): boolean {
    return (
      (this.isAdSalesAgency || this.isAdmin || this.isAgency) &&
      !this.profileIsTv &&
      this.noAgentsFeatureOrAgentsFeatureAndSuperUser()
    );
  }

  hasAgentFeature(): boolean {
    return this.hasFeature(FEATURE_AGENTS_MODULE);
  }

  hasHistoryData(): boolean {
    return this.hasFeature(FEATURE_AGENTS_HISTORIC_DATA_FOR_AGENTS_MATCH);
  }

  hasAgentsPrincipals(): boolean {
    return this.hasFeature(FEATURE_AGENTS_PRINCIPALS_MANAGEMENT);
  }

  hasAgentsDuplicatesFeature(): boolean {
    return (
      this.hasAgentFeature() &&
      !this.hasHistoryData() &&
      this.hasAgentsPrincipals() &&
      this.isAgentSuperUser()
    );
  }

  noAgentsFeatureOrAgentsFeatureAndSuperUser() {
    if (!this.hasFeature(FEATURE_AGENTS_MODULE)) {
      return true;
    }

    return this.isAgentSuperUser();
  }

  isAgentSuperUser(): boolean {
    return this.agentUserInfo?.superUser ?? false;
  }

  hasAgentFeatureAndIsNoSuperUser(): boolean {
    return this.hasFeature(FEATURE_AGENTS_MODULE) && !this.isAgentSuperUser();
  }
}
